import { NgModule } from '@angular/core';
import { LayoutResolver } from './layout/layout.resolver';

@NgModule({
    providers: [LayoutResolver],
})
export class ResolversModule {}
